import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { useContent } from "../content/ContentProvider";

interface Article {
  id: string;
  title: string;
  content: string;
  url: string;
  imageUrl?: string;
  createdAt: string;
}

export const ArticlePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { articlePage } = useContent();
  const [article, setArticle] = useState<Article | null>(null);

  useEffect(() => {
    const fetchArticle = async () => {
      const sheetID = "1Vni4h1oTW_Cm1R3sGp6L5oehKF8w5s2tek-exb6cprs";
      const apiKey = "AIzaSyAMjBP0MK_BPdGUsfRjb38O0nvh0qfB0C8";
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/Sheet1?key=${apiKey}`;

      try {
        const response = await fetch(url);
        const rows = await response.json();
        const articles = rows.values.slice(1).map((row: string[]) => ({
          id: row[0],
          title: row[1],
          content: row[2],
          url: row[3],
          imageUrl: row[4] || "",
          createdAt: row[5],
        }));
        const selectedArticle = articles.find((a: Article) => a.id === id);
        setArticle(selectedArticle || null);
      } catch (error) {
        console.error("Errore:", error);
      }
    };

    fetchArticle();
  }, [id]);

  if (!article) return <div>{articlePage.loading}</div>;

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navigazione */}
      <Navigation />

      {/* Contenuto principale */}
      <main className="container mx-auto flex-grow py-20 px-4">
        <h1 className="text-3xl font-bold mb-6 text-fuchsia-600 text-center">
          {article.title}
        </h1>
        {article.imageUrl && (
          <div className="flex justify-center items-center mb-6">
            <div
              className="w-80 h-80 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center"
              style={{ backgroundColor: "#F7D2F4" }}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        )}
        <p className="mb-4 text-dark text-center">{article.content}</p>

        <div className="text-center">
          <a
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-fuchsia-500 hover:text-fuchsia-700 underline transition-colors duration-300"
          >
           {articlePage.readMore}
          </a>
        </div>
      </main>

      {/* Footer */}
      <Footer property="desktop" />
    </div>
  );
};
